import { render } from "./Collapse.vue?vue&type=template&id=19509af6&scoped=true"
import script from "./Collapse.vue?vue&type=script&lang=js"
export * from "./Collapse.vue?vue&type=script&lang=js"

import "./Collapse.vue?vue&type=style&index=0&id=19509af6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19509af6"],['__file',"src/components/mdbvue/Advanced/Collapse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19509af6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19509af6', __exports__)) {
    api.reload('19509af6', __exports__)
  }
  
  module.hot.accept("./Collapse.vue?vue&type=template&id=19509af6&scoped=true", () => {
    api.rerender('19509af6', render)
  })

}


export default __exports__